import React from 'react'

const { Provider, Consumer } = React.createContext()
const ConfigProvider = Provider
const ConfigConsumer = Consumer

export { ConfigProvider, ConfigConsumer }



// WEBPACK FOOTER //
// ./src/contexts/config-context.js